import Alert from '@mui/material/Alert';
import { useParams } from 'react-router';

import { useGetContactQuery } from 'store/api/version-api.slice';
import { LoadingSkeleton } from 'components';

import InfoDetail from '../components/DetailItem';
import { getPrimaryMemberName } from '../utils';

const PrimaryMemberContainer = () => {
	const { primary_member, portal_id } = useParams();

	const { data = {}, isLoading } = useGetContactQuery({
		primaryMember: primary_member,
		portalId: portal_id
	});

	const primaryMember = getPrimaryMemberName(data);

	return (
		<LoadingSkeleton isLoading={isLoading}>
			<Alert variant="outlined" severity="info">
				<InfoDetail label="Primary Member" value={primaryMember} />
			</Alert>
		</LoadingSkeleton>
	);
};

export default PrimaryMemberContainer;
